var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRbSignalling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z",
    transform: "translate(-252 -1392.001) translate(252 1392.001)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.829 14.59a2.148 2.148 0 1 0 2.166 2.147 2.156 2.156 0 0 0-2.166-2.147zm6.5 2.147a6.5 6.5 0 1 0-9.752 5.573l1.094-1.868a4.337 4.337 0 1 1 4.321-.005l1.091 1.863a6.409 6.409 0 0 0 3.244-5.563zM14.829 6a10.712 10.712 0 0 0-5.42 20.019l1.083-1.858a8.609 8.609 0 1 1 13-7.425 8.576 8.576 0 0 1-4.326 7.43l1.083 1.858A10.716 10.716 0 0 0 14.829 6z",
    transform: "translate(-252 -1392.001) translate(249 1387.999)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRbSignalling);
export default __webpack_public_path__ + "static/media/rb-signalling.de358ea3aefe6510a80ecd2f1ce54210.svg";
export { ForwardRef as ReactComponent };